import React from "react";
import { Box, Heading, Text, Icon, HStack } from "@chakra-ui/react";
import { FaBeer, FaCoffee } from "react-icons/fa"; // Import the specific icons you want to use
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleDot,
  faHome,
  faSquare,
  faSyringe,
  faTableList,
  faFileLines,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons";

const TextSet = ({ type, label, icon }) => {
  const iconMap = {
    beer: FaBeer,
    coffee: FaCoffee,
    syringe: faSyringe,
    document: faFileInvoice,
    table: faTableList,
    documentLines: faFileLines,
    // Add more icons as needed
  };

  const SelectedIcon = iconMap[icon];

  switch (type) {
    case "header":
      return (
        <Box display="flex" alignItems="center" mt={3} mb={3}>
          <HStack spacing={5}>
            {SelectedIcon && <FontAwesomeIcon icon={SelectedIcon} size="xl" />}
            <Heading size="lg" mr={5}>
              {label}
            </Heading>
          </HStack>
        </Box>
      );
    case "subheader":
        return (
          <Box display="flex" alignItems="center" mt={3} mb={3}>
            <HStack spacing={3}>
              {SelectedIcon && <FontAwesomeIcon icon={SelectedIcon} size="lg" />}
              <Heading size="md" mr={5}>
                {label}
              </Heading>
            </HStack>
          </Box>
        );
    case "body":
      return <Text>{label}</Text>;
    default:
      return <Text>{label}</Text>;
  }
};

export default TextSet;
